import { PopulatedAssessment } from '../../types/app/populated'
import { AdminAssessmentData } from '../../types/assessments/assessment'
import { AssessmentStatus } from '../../types/utils/medical'
import { mergeData } from '../../utils/data'
import { getInsuranceCallInRequired } from '../callIn'
import { getQuestionnaireSummaryComplete } from '../summary'

// const getAssessmentNotRequired = (data?: FieldMapValue) => {
//   const notPregnant = data?.insuranceInfo?.option === 'not-pregnant'
//   if (!notPregnant) return false
//   const notPregnantOption = data?.insuranceInfo?.notPregnantOption
//   if (!notPregnantOption) return false
//   switch (notPregnantOption) {
//     case 'current-plan':
//       return false
//     default:
//       return true
//   }
// }

export const getAssessmentStatus = (
  admin: boolean,
  assessment: PopulatedAssessment,
  adminData?: AdminAssessmentData | PopulatedAssessment | null,
): AssessmentStatus => {
  if (assessment) {
    const data = mergeData(assessment.data ?? {}, assessment.corrections ?? {})
    if (getInsuranceCallInRequired(assessment) && assessment.insuranceCallInComplete)
      return 'call-in-complete'
    if (assessment.resultsViewedOn) return 'viewed'
    if (assessment.sentOn) return 'sent'
    if (adminData?.draftSavedOn) return 'draft-saved'
    if (assessment.submittedOn) return 'submitted'
    if (data) {
      const questionnaireSummaryComplete = getQuestionnaireSummaryComplete(
        admin ? (assessment?.mergedData ?? {}) : (assessment?.data ?? {}),
      )
      return questionnaireSummaryComplete ? 'questions-complete' : 'incomplete'
    }
  }
  return 'awaiting-questionnaire'
}
